export const languageChineseTraditional = {
    "formating": {
        "main": "主要提示詞",
        "jailbreak": "越獄提示詞",
        "chats": "歷史聊天",
        "lorebook": "Lorebook",
        "globalNote": "全域備註",
        "authorNote": "作者備註",
        "lastChat": "前一次聊天",
        "description": "角色描述",
        "personaPrompt": "使用者提示詞",
        "plain": "基礎提示詞",
        "memory": "Supa/HypaMemory",
        "postEverything": "系統提示詞結束"
    },
    "errors": {
        "toomuchtoken": "錯誤：所需的 Token 數超過了可用的最大上下文大小",
        "unknownModel": "錯誤：無法識別所選的模型",
        "httpError": "錯誤：請求發生錯誤：",
        "noData": "無法找到檔案中的資料，或者檔案已經損毀",
        "onlyOneChat": "至少需要一個聊天室",
        "alreadyCharInGroup": "該群組中已經有一個同名角色。",
        "noUserIcon": "請先設定您的個人頭像。",
        "emptyText": "文字內容為空。",
        "wrongPassword": "密碼錯誤",
        "networkFetch": "這通常是由於網路連線不穩定或伺服器故障引起的。",
        "networkFetchWeb": "這可能是由 CORS 錯誤引起的。這種情況只會在使用網頁版時發生，因為瀏覽器存在一些限制。請嘗試使用本地版或其他版本的叡甦。",
        "networkFetchPlain": "這可能是一次資料抓取（Fetch）錯誤。請嘗試在設定中關閉強制抓取選項。",
        "requestLogRemoved": "該請求記錄已被刪除。",
        "requestLogRemovedDesc": "當用戶端重新整理或加載時，該請求記錄會被刪除。"
    },
    "showHelp": "顯示幫助",
    "help": {
        "model": "此模型是指聊天中使用的主要模型。",
        "submodel": "輔助模型是一個用於分析情感圖片、產生自動建議等的模型，推薦使用 GPT-3.5。",
        "oaiapikey": "OpenAI 的 API 金鑰（Key），可在 https://platform.openai.com/account/api-keys 取得。",
        "mainprompt": "主要提示詞設定用於決定模型的預設行為。",
        "jailbreak": "當角色中的越獄開關被啟動後，越獄提示詞將被使用。",
        "globalNote": "一個對模型行為有強烈影響的備註（也稱為 UJB），適用於所有角色。",
        "autoSuggest": "用於自動建議使用者回應時生成選項的提示詞。",
        "formatOrder": "提示詞的排列順序：越靠下的區塊對模型的影響越大。",
        "forceUrl": "此欄位不為空時，請求將被發送到您所輸入的網址。",
        "tempature": "較低的數值會使角色更緊密地遵循提示詞，但會使回應更制式與機械化。\n較高的數值則會增強角色的創意表現，但回應可能會變得不穩定。",
        "frequencyPenalty": "較高的數值可以避免角色在個別回應中重複使用相同的詞彙，但回應也更容易出現語意混亂。",
        "presensePenalty": "較高的數值可以避免角色在整體對話中重複使用相同的詞彙，但這也可能導致回答失去一致性和穩定性。",
        "sdProvider": "圖片生成提供者。",
        "msgSound": "當角色回應時，播放 *叮* 的提示音",
        "charDesc": "角色的簡要描述。這會影響角色的回應方式。",
        "charFirstMessage": "角色的初始訊息，這會極大地影響角色的回應方式。",
        "charNote": "對模型行為有強烈影響的備註，嵌入到當前角色中，也稱為 UJB。",
        "toggleNsfw": "切換越獄提示詞的開關。",
        "lorebook": "Lorebook 是由使用者創建的 AI 辭典，只有當上下文中包含關鍵字時 AI 才能看到它。",
        "loreName": "Lorebook 的名稱，不影響 AI。",
        "loreActivationKey": "當上下文中包含任一關鍵字時，該條目將被啟用，並啟動相應的提示詞。使用逗號分隔。",
        "loreorder": "插入順序越高，對模型的影響力越大。在啟動大量條目時，也更不容易被截斷。",
        "bias": "Bias 是一組鍵值數據，用於修改某些字串出現的機率。\n其數值範圍可以是 -100 到 100。較高的數值會使該字串更可能出現，較低的數值則降低出現機率。\n另外，在某些模型中，若將數值設為 -101，該字串將被標記為「強制禁止詞」。\n警告：若 Tokenizer 設定有誤，可能無法正常運作。",
        "emotion": "「表情立繪會根據角色情緒顯示對應的圖片。具體的情緒由角色的回應進行分析。您必須輸入情緒名稱作為詞彙*（如：joy, happy, fear 等）*。若存在名為 **neutral** 的情緒，將作為默認情緒。至少需要三張圖片才能正常運作。」",
        "imggen": "分析聊天內容後，將提示套用至 {{slot}}。",
        "regexScript": "正規表達式（Regex Script）是一個自定義工具，用於將符合條件的字串由「IN」替換為「OUT」。\n\n有四種類型選項：\n\n- **修改輸入（Modify Input）**：修改使用者的輸入內容\n\n- **修改輸出（Modify Output）**：修改角色的輸出內容\n\n- **修改請求資料（Modify Request Data）**：在當前聊天資料發送時進行修改\n\n- **修改顯示（Modify Display）**：僅修改顯示的文字，不更改聊天資料\n\n「IN」必須是一個不帶標誌（flags）的正規表達式，且開頭和結尾不包含斜線。\n\n「OUT」是一個可以包含替換模式的字串。這些替換模式如下：\n\n- $$\n\n  - 插入符號「$」\n\n- $&\n\n  - 插入匹配到的子字串\n\n- $`\n\n  - 插入匹配子字串前的部分\n\n- $1\n\n  - 插入第一個匹配群組，可以替換為其他數字（例如 2、3...）\n\n- $(name)\n\n  - 插入命名群組\n\n針對標誌（flags），除了原生支援的標誌之外，還可以使用下列專為進階使用者設計的標誌：\n\n- `<inject>`：將結果注入當前字串中\n- `<move_top>`：將結果移到字串的頂部\n- `<move_bottom>`：將結果移到字串的底部\n- `<repeat_back>`：如果找不到匹配，則使用上一個匹配的結果\n- `<order n>`：設定結果的順序，數值越高顯示越靠前。「n」代表一個數字（例如 `<order 1>`）。如果未設定，默認為 0。\n- `<cbs>`：解析「IN」中的大括號語法\n\n若要與原生標誌結合使用，可以像這樣使用：`gi<cbs><move_top>`。",
        "experimental": "此為實驗性功能，可能不穩定。",
        "oogaboogaURL": "如果您的 WebUI 支援舊版 API，您的 URL 應類似於 *https://.../run/textgen*。\n\n如果您的 WebUI 支援新版 API，您的 URL 應類似於 *https://.../api/v1/generate*，且將使用 API 伺服器作為主機，並在參數中添加 —api。",
        "exampleMessage": "示範對話會影響角色的回應，但不會永久佔用 Token。\n\n對話格式示例：\n\n```\n<START>\n{{user}}: hi\n{{char}}: hello\n<START>\n{{user}}: hi\nHaruhi: hello\n```\n\n```<START>``` 標記了一段新對話的開始。",
        "creatorQuotes": "說明將顯示在初始訊息之上，用於向使用者提供角色說明。此內容不會進入提示詞中。",
        "systemPrompt": "此欄位不為空時，將替換設定中的主要提示詞為此內容。",
        "chatNote": "這是一個強烈影響模型行為的備註，嵌入於當前聊天中，也稱為記憶或 UJB。",
        "personality": "對角色性格的簡要描述。\n\n**不建議使用此欄位，請填寫在角色描述中。**",
        "scenario": "對角色情境的簡要描述。\n\n**不建議使用此欄位，請填寫在角色描述中。**",
        "utilityBot": "啟用後，將忽略主要提示詞、越獄提示詞和其他提示詞。適用於工具型機器人，而非用於角色扮演。",
        "loreSelective": "啟用選擇性模式後，需同時匹配關鍵字與次要關鍵字，方可啟用該條目。",
        "loreRandomActivation": "啟用「使用機率條件」後，若同時符合啟用條目的其他條件，則在每次發送聊天時，該條目將依照設定的機率被使用。",
        "additionalAssets": "在聊天中顯示的額外資源。\n\n - 使用 `{{raw::<資源名稱>}}` 作為路徑。\n - 使用 `{{image::<資源名稱>}}` 作為圖片。\n - 使用 `{{video::<資源名稱>}}` 作為影片。\n - 使用 `{{audio::<資源名稱>}}` 作為音訊。\n    - 建議放置在背景 HTML 中。",
        "superMemory": "SuperMemory 通過向 AI 提供摘要資料來增強角色的記憶能力。\n\nSuperMemory 是一個文本摘要功能，推薦使用 davinci 模型。不建議使用輔助模型，除非它是未經過濾、最大上下文長度超過 2000 Tokens，且具有良好摘要能力的模型。\n\nSuperMemory 提示詞決定了模型如何撰寫摘要。留空將使用預設提示詞，建議保持留空。\n\n完成所有設定後，您可以在角色的設定中啟用此功能。",
        "replaceGlobalNote": "此欄位不為空時，將替換當前的全域備註為此內容。",
        "backgroundHTML": "將 Markdown/HTML 注入到聊天畫面的背景中。\n\n您也可以使用額外資源。例如，您可以使用 {{audio::<資源名稱}} 作為背景音樂。\n\n此外，您還可以與額外資源搭配使用以下格式：\n - {{bg::<資源名稱>}}：將資源設為背景。",
        "additionalText": "只有當 AI 認為有必要時，才會將該段文本添加到角色描述中。您可以在此處放置較長的文本。使用雙換行進行內容分隔。",
        "charjs": "這是一段會與角色一同運行的 JavaScript。詳情請查看：https://github.com/kwaroran/RisuAI/blob/main/src/etc/example-char.js\n**出於安全原因，目前不建議使用。這些代碼不會被包含在匯出中。**",
        "romanizer": "Romanizer 是一個將非羅馬字母轉換為羅馬字母的外掛程式，用於減少請求資料時的 Token。這可能會導致輸出結果與原始模型不同。如果已在聊天中使用羅馬字母，不建議啟用。",
        "oaiRandomUser": "啟用後，請求中的使用者參數將被隨機 UUID 替代，並在重新整理時修改。這可以用來防止 AI 識別使用者。",
        "inlayImages": "啟用後，圖片可嵌入聊天中，並且支援此功能的 AI 將能夠看到它們。",
        "metrica": "Metric Systemizer 是一個外掛程式，會在請求階段將公制單位轉換為英制單位，而在輸出時轉回公制，讓使用者在介面上顯示公制單位，但效能上使用英制單位。如果在聊天中已經使用英制單位，不建議啟用。",
        "lorePlus": "LoreBook+ 是一項實驗性功能。使用向量資料庫（VectorDB），而不僅是字串匹配。目的在於提供更好的機器人創建體驗和更好的匹配效能。",
        "topP": "Top P 是核心採樣（Nucleus Sampling）的機率閾值，模型只會考慮總機率品質達到 top_p 的 Token 結果。",
        "openAIFixer": "OpenAI Fixer 是一個用於修復 OpenAI 部分問題的外掛程式。",
        "sayNothing": "啟用後，如果使用者沒有輸入聊天內容，系統會自動填入 ’say nothing‘。",
        "showUnrecommended": "啟用後，將顯示不建議使用的過時設定。不建議使用這些設定。",
        "imageCompression": "啟用後，在匯出角色時會壓縮圖片。如果動畫圖片無法顯示，請嘗試關閉此選項。",
        "useExperimental": "啟用後，將顯示部分實驗性功能。",
        "forceProxyAsOpenAI": "啟用後，使用反向代理（Reverse proxy）時將強制使用 OpenAI 格式。",
        "forcePlainFetch": "啟用後，將使用瀏覽器的 Fetch API 來替代原生 HTTP 請求。這可能會導致 CORS 錯誤。",
        "autoFillRequestURL": "啟用後，將自動填入請求 URL 以匹配當前模型。",
        "chainOfThought": "啟用後，將在提示詞中添加思維鏈（CoT, Chain-of-Thought）提示。",
        "gptVisionQuality": "此選項用於設定圖片檢測模型的品質。品質越高，檢測越準確，但會使用更多的 Token。",
        "genTimes": "此設定支援模型上的重滾（reroll）回應數量。除第一則回應外，其他回應將作為快取使用，以降低成本。但若未多次重滾回應，可能增加成本。",
        "requestretrys": "此選項用於設定請求失敗時的重試次數。",
        "emotionPrompt": "此選項用於設定情緒檢測的提示詞。留空將使用預設提示詞。",
        "removePunctuationHypa": "啟用後，將在執行 HypaMemory 前移除標點符號。",
        "additionalParams": "此選項允許將附加的參數添加到請求主體（Request body）中。若要排除某些參數，可以將值設為 `{{none}}`。若要添加標頭（Request header）而非主體，可以在鍵前加上 `header::`，如 `header::Authorization`。若要將值作為 JSON，可以在值前加上 `json::`，如 `json::{\"key\":\"value\"}`。其他情況下，系統將自動判定值的類型。",
        "antiClaudeOverload": "若 Claude 過載發生，叡甦會透過繼續相同的提示來阻止它，以減少過載的機率。此功能僅適用於流式回應（Streamed Responses），對非官方 API 端點可能無效。",
        "triggerScript": "觸發式（Trigger）是一個自定義指令碼，在符合條件時執行。可用於修改聊天資料、執行指令、更改變數等。類型取決於觸發時的情況，也可由按鈕觸發，如 {{button::Display::TriggerName}} 或帶有 risu-trigger=\"<TriggerName>\" 屬性的 HTML 按鈕。",
        "autoContinueChat": "啟用後，當聊天不以標點符號結束時，系統將嘗試繼續對話。請勿在不使用標點符號的語言中啟用此功能。",
        "combineTranslation": "啟用後，將把被 HTML 標籤分隔但屬於同一句的文本合併後進行翻譯，並在翻譯結果上重新套用「修改顯示」（Modify Display）。這有助於提高翻譯的準確性。若啟用此後介面出現異常，請關閉此選項並回報問題。",
        "dynamicAssets": "啟用後，若在處理資料時找不到資源名稱，系統將使用向量搜尋（Vector Search）嘗試尋找最接近的資源名稱並進行替換。",
        "dynamicAssetsEditDisplay": "啟用後，動態資源將同樣應用於「修改顯示」階段，但這可能會影響效能。",
        "nickname": "設定後，將在聊天中以此暱稱取代角色名稱，並顯示於 {{char}} 和 <char>。",
        "useRegexLorebook": "啟用後，Lorebook 將改用正規表達式（Regex）搜尋，而不再使用字串匹配。格式為 /regex/flags。",
        "customChainOfThought": "警告：不再建議使用思維鏈（CoT, Chain-of-Thought）切換功能。請將相關提示詞移至其他提示詞欄位。",
        "customPromptTemplateToggle": "可在此處設定自定義提示詞切換功能。使用 `<toggle variable>=<toggle name>` 格式，每行一個，例如：`cot=Toggle COT`。您可以在提示詞中透過 `{{getglobalvar::toggle_<toggle variable>}}` 語法來使用這些切換功能，如：`{{getglobalvar::toggle_cot}}`。",
        "defaultVariables": "可在此處設定自訂預設變數。使用 `<variable name>=<variable value>` 格式，每行一個。例如：`name=叡甦`，可在觸發式和 CBS 變數中使用，如：`{{getvar::A}}`、`{{setvar::A::B}}` 或 `{{? $A + 1}}`。若提示詞範本的預設變數與角色的預設變數名稱相同，系統將使用角色的預設變數。",
        "lowLevelAccess": "啟用後，將開放需要高計算能力的功能，並允許通過角色中的觸發式執行 AI 模型。除非確實需要這些功能，否則不要啟用此選項。",
        "triggerLLMPrompt": "這是將發送到模型的提示詞。您可以使用 `@@role user`、`@@role system`、`@@role assistant` 來設定多輪對話及角色。例如：\n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "啟用後，將使用舊版翻譯方法，在翻譯前對 Markdown 和引號進行預處理，而非在翻譯後處理。",
        "luaHelp": "可使用 Lua 作為觸發式，並可定義 onInput、onOutput 和 onStart 函數。當使用者發送消息時，調用 onInput；當角色發送消息時，調用 onOutput；當對話開始時，調用 onStart。詳情請參閱說明文檔。",
        "claudeCachingExperimental": "Claude 快取是實驗性功能，可減少模型成本。但若在不使用重滾（reroll）回應的情況下啟用，則可能增加成本。實驗性功能可能不穩定，且未來可能會有所變動。",
        "urllora": "可使用模型文件的直接下載鏈接。通過類似 https://sites.google.com/site/gdocs2direct/ 的網站，從 Google Drive 等平台產生直接連接。或者使用 Civitai URL，複製 AIR（格式如 `urn:air:flux1:lora:civitai:180891@776656` 或 `civitai:180891@776656`），並貼上。",
        "namespace": "命名空間（Namespace）是模組的唯一標識符，用於防止模組衝突，並與預設和其他模組等進行互動。若不確定如何填寫，建議留空。",
        "moduleIntergration": "可在模組整合區域中輸入模組的命名空間（Namespace）來啟用模組。若要啟用多個模組，可用逗號分隔，例如：`module1,module2,module3`。此功能便於高級使用者通過預設靈活運用模組。",
        "customCSS": "自訂 CSS 樣式。若出現問題，可使用 (Ctrl + .) 啟用或禁用。",
        "betaMobileGUI": "啟用後，將在小於 800px 的螢幕上使用測試版行動介面，需重新整理頁面。",
        "unrecommended": "這是一個不建議使用的設定。建議關閉。",
        "jsonSchema": "JSON Schema 將在 AI 模型支援時發送給模型。\n\n然而，由於 JSON Schema 學習難度較高，在叡甦中，您可以使用 TypeScript 接口的子集來代替 JSON Schema。叡甦將在運行時進行轉換。例如，如果您想發送如下的JSON：\n\n```js\n{\n  \"name\": \"叡甦\", // name 必須是叡甦，\n  \"age\": 1, // age 必須是數字，\n  \"icon\": \"slim\", // icon 必須是 ’slim‘ 或 ’rounded‘\n  \"thoughts\": [\"Good View!\", \"Lorem\"] // thoughts 必須是字符串數組\n}\n```\n\n您可以使用以下 TypeScript 接口：\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: ’slim‘|’rounded‘\n  thoughts: string[]\n}\n```\n\n接口名稱不重要。欲了解更多資訊，請參閱 TypeScript 說明文件：https://www.typescriptlang.org/docs/handbook/interfaces.html 。要檢查支持的 TypeScript 子集，請查看以下內容。<details><summary>支持的 TypeScript 子集</summary>\n\n支援的類型包括 `boolean`、`number`、`string` 和 `Array`。高級類型不被支援（如：單元類型、交集類型、聯合類型、可選類型、字面量類型等），除了以下幾種情況：\n\n        - 原始資料型別（Primitive Type）的陣列（Array）：（如 `string[]`、`Array<boolean>`）\n        - 字符串之間的單值類型（Unit Types）：（例如 `’slim‘|’rounded‘`）\n\n        屬性必須在同一行內定義。若一行中有多個屬性，將會產生錯誤。屬性和接口名稱僅可使用拉丁字符，並在 ASCII 範圍內。屬性名稱不得以單引號或雙引號包裹。接口內部不支持嵌套。在定義屬性的行中，不能包含 `{` 或 `}`。如果想使用更高級的類型，請使用 JSON Schema。\n        </details>",
        "strictJsonSchema": "啟用後，某些模型將嚴格遵循提供的 JSON Schema。若禁用，可能會忽略 JSON Schema。",
        "extractJson": "此欄位不為空時，將從回應中提取特定的 JSON 資料。例如：想從回應 `{\"response\": {\"text\": [\"hello\"]}}` 中提取 `response.text[0]`，可以填寫 `response.text.0`。",
        "translatorNote": "可在此處為每個角色添加獨特的翻譯提示，但僅適用於使用 Ax. 模型進行翻譯。要啟用此功能，請在語言設定中包含 `{{slot::tnote}}`。此功能不適用群組聊天。",
        "groupInnerFormat": "用於定義群組聊天中非發言者角色的格式。此欄位不為空時，將使用此格式替代預設格式。若 `Group Other Bot Role` 設定為 `assistant`，該格式也將應用於發言者。",
        "groupOtherBotRole": "用於定義群組聊天中非發言者的角色。",
        "chatHTML": "每個聊天插入的 HTML。\n\n可以使用CBS和特殊標籤。\n- `<risutextbox>`：用於呈現文字的文本框\n- `<risuicon>`：用於顯示使用者或助理的頭像\n- `<risubuttons>`：用於聊天編輯、翻譯等圖示按鈕\n- `<risugeninfo>`：生成訊息按鈕。",
        "systemContentReplacement": "若模型不支援系統提示詞，則使用此格式取代系統提示詞內容。",
        "systemRoleReplacement": "若模型不支援系統角色，將使用此角色取代系統角色。",
        "summarizationPrompt": "用於摘要的提示詞。留空將使用預設提示詞。您也可以使用包含 {{slot}} 的 ChatML 格式來處理聊天數據。",
        "translatorPrompt": "用於翻譯的提示詞。留空將使用默認提示。您還可以使用帶有 {{slot}} 的 ChatML 格式表示目標語言：用 {{slot::content}} 表示內容，用 {{slot::tnote}} 表示翻譯註釋。",
        "translateBeforeHTMLFormatting": "啟用後，將在正規表達式和 HTML 格式化之前翻譯文本。這可能減少 Token 數，但可能破壞格式。",
        "autoTranslateCachedOnly": "啟用自動翻譯選項時，將只自動翻譯使用者先前已翻譯過的訊息。",
        "presetChain": "若欄位不為空，則每次使用者發送訊息時，系統會從此輸入中的預設列表中隨機變更並應用預設設定。預設列表應以逗號分隔，例如 `preset1,preset2`。",
        "legacyMediaFindings": "啟用後，將使用舊版方法尋找媒體資源，而不使用額外的搜尋演算法。",
        "comfyWorkflow": "請輸入 Comfy UI 的 API 工作流程。您可以在 Comfy UI 中點選「Workflow > Export (API)」按鈕以取得您的 API 工作流程。此外，您必須在工作流程文本中加入 {{risu_prompt}}，該佔位符將被 Risu 提供的提示詞替換。",
        "APIPool": "啟用後，系統將連接到 RisuAI 的 API 資源池。已啟用的使用者可共享免費、速率受限模型的 API 金鑰，從而利用其他使用者未充分使用的金鑰，增加對速率受限模型的請求次數。"
    },
    "setup": {
        "chooseProvider": "選擇 AI 提供者",
        "openaikey": "使用 OpenAI API 金鑰（推薦）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行設定",
        "inputApiKey": "請在此輸入 API 金鑰",
        "apiKeyhelp": "可在以下取得 API 金鑰：",
        "setupSelfHelp": "歡迎畫面結束後，可前往設定中自行配置。",
        "theme": "選擇介面主題",
        "themeDescWifulike": "不適合在行動裝置上使用",
        "themeDescWifuCut": "適合在行動裝置上使用",
        "themeDescClassic": "適用於所有裝置",
        "texttheme": "設定文字顏色",
        "inputName": "最後，請輸入您的暱稱。",
        "welcome": "歡迎使用 Risu（叡甦）！我將引導您進行設定。請問我該如何稱呼您？",
        "welcome2": "您好，{username}！在開始之前，我會問您一些問題，稍後可在設定中進行修改。\n\n首先，請選擇 AI 提供者。",
        "openrouterProvider": "Openrouter 提供許多模型，部分免費且未經內容過濾，但品質不如 OpenAI。",
        "hordeProvider": "Horde 提供免費服務，但回應時間較長且品質較低。",
        "setProviderLater": "還有其他提供者，您可以稍後在設定中配置。如想稍後設定，請選擇此選項。",
        "setupOpenAI": "使用 OpenAI，需要取得 API 金鑰（Key）。\n1. 前往 https://beta.openai.com/ \n2. 使用帳號登入 \n3. 前往 https://beta.openai.com/account/api-keys \n4. 點擊「Create New API Key」，並命名金鑰。 \n5. 複製該金鑰。 \n6. 返回叡甦\n7. 貼上金鑰並點擊「發送」。",
        "setupClaude": "使用 Claude，需要取得一個 API 金鑰（Key）。",
        "setupClaudeSteps": [
            "點擊此連結並使用 Google 帳號登錄",
            "輸入您的資料並點擊「繼續」（Continue）",
            "僅在第一個框中輸入任意名稱，然後點擊「建立帳號」（Create Account）",
            "點擊「購買點數」（Buy Credits）",
            "點擊「完成設定」（Complete Setup）",
            "輸入如上圖所示的內容，但國家／地區部分需自行輸入。完成後點擊「繼續」（Continue）",
            "新增付款方式後點擊「繼續」（Continue）",
            "付款完成後，點擊「新增資金」（Add Funds）。最低需新增 5 美元，或設定自動儲值功能",
            "新增資金後，前往控制台頁面，點擊「取得 API 金鑰」（Get API Keys）",
            "點擊「建立 API 金鑰」（Create API Key）",
            "輸入如上圖所示的內容後，點擊「新增」（Add）",
            "複製金鑰，將其貼到此處並發送。"
        ],
        "setupOpenrouter": "使用 Openrouter 需要獲取 API 金鑰（Key）。 \n1. 前往 https://openrouter.ai/keys\n2. 點擊「Create Key」\n3. 任意命名金鑰名稱。\n4. 複製該金鑰。\n5. 返回叡甦\n6. 貼上金鑰並點擊「發送」。",
        "allDone": "完成所有設定！請稍待片刻。",
        "setupLaterMessage": "歡迎，{username}！您希望我引導您完成設定還是自行設定？",
        "setupMessageOption1": "引導我完成設定",
        "setupMessageOption1Desc": "推薦新使用者使用",
        "setupMessageOption2": "由我自己完成設定",
        "claudeDesc": "Claude 是由 Antropic 開發的 AI 模型，是 OpenAI 的競爭對手。若您希望使用非英語語言，它優於 GPT。",
        "openAIDesc": "OpenAI GPT 是高品質的 AI 模型，但它付費且存在內容審核，在非英語環境下表現較弱。",
        "chooseChatType": "很好！現在請選擇聊天語言。",
        "chooseChatTypeOption1": "全英語",
        "chooseChatTypeOption1Desc": "推薦英語使用者。AI 將使用英語進行輸入和輸出。",
        "chooseChatTypeOption2": "英語處理",
        "chooseChatTypeOption2Desc": "推薦非英語使用者。AI 內部使用英語處理，但輸入輸出為您的語言。",
        "chooseChatTypeOption3": "無語言側重",
        "chooseChatTypeOption3Desc": "AI 將使用您的語言處理，但可能會降低回應品質。",
        "chooseCheapOrMemory": "除此之外，您更傾向於記憶功能還是節省成本？",
        "chooseCheapOrMemoryOption1": "記憶功能",
        "chooseCheapOrMemoryOption1Desc": "AI 會記住更多內容，但費用較高。",
        "chooseCheapOrMemoryOption2": "省錢模式",
        "chooseCheapOrMemoryOption2Desc": "AI 會記住較少內容，但費用更低。",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "AI 記住的內容多於省錢模式，但不及使用記憶功能。",
        "chooseCheapOrMemoryOption4": "無限制",
        "chooseCheapOrMemoryOption4Desc": "AI 會記住幾乎所有內容，但費用極高。",
        "finally": "最後，您是否希望使用進階工具？",
        "finallyOption1": "是",
        "finallyOption1Desc": "使用進階工具會使界面變得更複雜。推薦進階使用者使用。",
        "finallyOption2": "否",
        "finallyOption2Desc": "不使用高級工具將使界面更簡潔。推薦新使用者使用。",
        "openAIProvider": "OpenAI GPT 是高品質的 AI 模型，但需付費且經內容審核。"
    },
    "confirm": "確定",
    "goback": "返回",
    "botSettings": "機器人設定",
    "model": "模型",
    "apiKey": "API 金鑰",
    "providerURL": "請求地址（URL）",
    "providerJSON": "請求主體（JSON）",
    "mainPrompt": "主要提示詞",
    "jailbreakPrompt": "越獄提示詞",
    "globalNote": "全域備註",
    "autoSuggest": "自動建議",
    "tokens": "Tokens",
    "maxContextSize": "最大上下文長度（Max Context Size）",
    "maxResponseSize": "最大回應長度（Max Response Size）",
    "temperature": "溫度（Temperature）",
    "frequencyPenalty": "頻率懲罰（Frequency Penalty）",
    "presensePenalty": "存在懲罰（Presence Penalty）",
    "advancedSettings": "進階設定",
    "advancedSettingsWarn": "警告：若不確定該選項的作用，請勿進行修改！",
    "formatingOrder": "格式順序",
    "authorNote": "作者備註",
    "firstMessage": "初始訊息",
    "description": "描述",
    "note": "說明",
    "jailbreakToggle": "使用越獄提示詞",
    "charIcon": "角色頭像",
    "characterDisplay": "角色展示",
    "viewScreen": "額外角色畫面",
    "none": "無",
    "emotionImage": "表情立繪",
    "noImages": "沒有圖片",
    "noBias": "No Bias",
    "image": "圖片",
    "name": "名稱",
    "folderName": "資料夾名稱",
    "folderRemoveConfirm": "此資料夾包含世界書。確定要刪除它及其所有內容嗎？",
    "emotion": "情緒名稱",
    "value": "值",
    "reroll": "重新生成",
    "chatList": "聊天列表",
    "removeChat": "確定要移除此訊息嗎？",
    "loreBook": "Lorebook",
    "character": "角色",
    "Chat": "聊天",
    "globalLoreInfo": "角色 Lorebook 適用於該角色的所有對話。",
    "group": "群組",
    "groupLoreInfo": "群組 Lorebook 適用於該群組的所有對話。",
    "localLoreInfo": "聊天 Lorebook 僅用於此對話。",
    "removeConfirm": "您確定要刪除：",
    "removeConfirm2": "您**真的**確定要刪除：",
    "exportConfirm": "您想要匯出此資料嗎？",
    "insertOrder": "插入順序",
    "activationKeys": "關鍵字",
    "activationKeysInfo": "使用逗號分隔",
    "prompt": "提示詞",
    "loreBookDepth": "Lorebook 搜尋深度",
    "loreBookToken": "Lorebook 最大 Token 數",
    "removeCharacter": "刪除角色",
    "removeGroup": "刪除群組",
    "exportCharacter": "匯出角色",
    "userSetting": "使用者設定",
    "username": "您的名稱",
    "userIcon": "您的頭像",
    "successExport": "已成功匯出並保存至您的下載資料夾",
    "successImport": "成功匯入",
    "importedCharacter": "匯入角色",
    "alwaysActive": "始終啟用",
    "additionalPrompt": "附加提示詞",
    "descriptionPrefix": "描述前綴",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "正在使用輔助模型。",
    "plugin": "外掛程式",
    "language": "語言",
    "UiLanguage": "介面語言",
    "createfromScratch": "自行創建",
    "importCharacter": "匯入角色",
    "translator": "翻譯器",
    "disabled": "關閉",
    "noPluginSelected": "已選擇模型為外掛程式，但未選擇外掛。",
    "text": "文字",
    "UISize": "聊天文字大小",
    "newVersion": "發現更新，是否進行安裝？",
    "display": "顯示 & 音訊",
    "useCustomBackground": "自訂背景",
    "translateInput": "翻譯輸入",
    "autoTranslation": "自動翻譯",
    "fullscreen": "全螢幕",
    "playMessage": "播放訊息音效",
    "iconSize": "頭像大小",
    "createGroup": "建立群組",
    "groupIcon": "群組頭像",
    "single": "單個",
    "multiple": "多個",
    "useCharLorebook": "使用角色 Lorebook",
    "selectChar": "選擇角色",
    "askLoadFirstMsg": "是否載入初始訊息？",
    "theme": "介面主題",
    "editOrder": "編輯順序",
    "autoMode": "自動模式",
    "submodel": "輔助模型",
    "timeOutinSec": "超時時間（秒）",
    "emotionPrompt": "情緒提示詞",
    "singleView": "單角色模式",
    "SpacedView": "多角色模式",
    "emphasizedView": "雙角色模式",
    "pluginWarn": "但安裝惡意外掛可能導致問題。",
    "createGroupImg": "產生群組頭像",
    "waifuWidth": "角色對話框寬度",
    "savebackup": "備份至 Google",
    "loadbackup": "從 Google 讀取備份",
    "files": "檔案",
    "backupConfirm": "您確定要保存備份嗎？",
    "backupLoadConfirm": "您確定要讀取備份嗎？所有資料將被覆蓋！",
    "backupLoadConfirm2": "您**真的、真的**確定要加載備份嗎？這將會清除所有資料！",
    "pasteAuthCode": "請從彈出窗口複製驗證碼並貼入：",
    "others": "其他",
    "presets": "預設設定",
    "imageGeneration": "圖片生成",
    "provider": "提供者",
    "key": "金鑰（Key）",
    "noData": "沒有資料",
    "currentImageGeneration": "當前圖片生成數據",
    "promptPreprocess": "使用提示詞預處理",
    "SwipeRegenerate": "使用滑動箭頭重新產生訊息",
    "instantRemove": "刪除訊息時連帶刪除後續訊息",
    "instantRemoveConfirm": "您想只刪除一條訊息嗎？若選擇「否」，後續訊息也將被刪除。",
    "textColor": "文字顏色",
    "classicRisu": "經典 Risu",
    "highcontrast": "高對比度",
    "quickPreset": "可通過 Ctrl +（預設順序編號）快速切換預設。",
    "requestretrys": "請求失敗時重試",
    "utilityBot": "工具機器人",
    "ShowLog": "顯示請求記錄",
    "waifuWidth2": "角色顯示寬度",
    "sayNothing": "無輸入內容時自動填入 ’say nothing‘",
    "regexScript": "正規表達式",
    "type": "類型",
    "editInput": "修改輸入",
    "editOutput": "修改輸出",
    "editProcess": "修改請求資料",
    "loadLatest": "讀取最新的備份",
    "loadOthers": "讀取其他備份",
    "exampleMessage": "示範訊息",
    "creatorNotes": "創建者備註",
    "systemPrompt": "系統提示詞",
    "characterNotes": "角色備註",
    "personality": "性格",
    "scenario": "場景",
    "alternateGreetings": "備選問候語",
    "unrecommended": "不建議",
    "chatNotes": "聊天備註",
    "showUnrecommended": "顯示不建議的設定",
    "altGreet": "備選初始訊息",
    "scripts": "指令碼",
    "settings": "設定",
    "selective": "選擇性",
    "SecondaryKeys": "次要關鍵字",
    "useGlobalSettings": "使用全域設定",
    "recursiveScanning": "遞迴掃描",
    "creator": "創建者",
    "CharVersion": "角色版本",
    "Speech": "語音",
    "ToggleSuperMemory": "啟用 SupaMemory",
    "SuperMemory": "SupaMemory",
    "useExperimental": "啟用實驗性功能",
    "showMemoryLimit": "顯示記憶上限",
    "roundIcons": "圓形頭像",
    "streaming": "即時串流傳輸",
    "chatBot": "聊天機器人",
    "otherBots": "其他機器人",
    "user": "使用者",
    "additionalAssets": "額外資源",
    "editDisplay": "修改顯示",
    "community": "社群",
    "textBackgrounds": "自訂文本視窗顏色",
    "textBorder": "文字邊框",
    "textScreenRound": "圓角化文本視窗",
    "textScreenBorder": "文本視窗邊框",
    "ttsReadOnlyQuoted": "僅朗讀引號內容",
    "ttsStop": "停止語音合成",
    "askRemoval": "刪除訊息前進行確認",
    "replaceGlobalNote": "替換全域備註",
    "charLoreBook": "角色 Lorebook",
    "globalLoreBook": "全域 Lorebook",
    "globalRegexScript": "全域正規表達式",
    "accessibility": "輔助功能",
    "sendWithEnter": "使用 Enter 鍵發送（取消检查时Shift + Enter更改为消息传送。）",
    "fixedChatTextarea": "固定聊天窗口底部",
    "clickToEdit": "點擊文字進行編輯",
    "setNodePassword": "設定密碼以提升安全性",
    "inputNodePassword": "輸入密碼。如果忘記密碼，請刪除伺服器文件中的 save/__password.txt 並重啟伺服器。",
    "simple": "基本",
    "advanced": "進階",
    "askReRollAutoSuggestions": "自動滾動建議",
    "creatingSuggestions": "正在產生建議⋯",
    "orderByOrder": "按順序對話",
    "removeFromGroup": "確定要將 {{char}} 移出群組嗎？",
    "talkness": "健談度",
    "active": "活躍",
    "loreRandomActivation": "啟用機率條件",
    "activationProbability": "機率",
    "shareCloud": "分享至 RisuRealm",
    "hub": "RisuRealm",
    "tags": "標籤",
    "backgroundHTML": "背景嵌入",
    "copied": "已複製",
    "useChatCopy": "啟用聊天訊息複製",
    "useChatSticker": "啟用聊天貼圖",
    "useAdditionalAssetsPreview": "使用額外資源預覽",
    "autoTranslateInput": "自動輸入翻譯",
    "enterMessageForTranslateToEnglish": "輸入訊息以翻譯成英文",
    "recent": "最新",
    "downloads": "下載",
    "trending": "熱門",
    "imageCompression": "圖片壓縮",
    "notLoggedIn": "尚未登入 Risu 帳號",
    "googleDriveInfo": "連接至 Google Drive 以同步資料。",
    "googleDriveConnection": "連接 Google Drive",
    "googleDriveConnected": "已連接 Google Drive",
    "SaveDataInAccount": "保存資料到帳號",
    "dataSavingInAccount": "正在將資料保存到帳號",
    "logout": "登出",
    "loadDataFromAccount": "從帳號讀取資料",
    "saveCurrentDataToAccount": "保存目前資料到帳號",
    "chatAssumed": "",
    "proxyAPIKey": "代理金鑰/密碼",
    "proxyRequestModel": "請求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "歡迎查看叡甦官方的 Wiki。",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "叡甦官方的 Discord 伺服器",
    "confirmRecommendedPreset": "此模型有建議設定，是否更改為建議設定？（可在輔助功能中關閉提示）",
    "toggleConfirmRecommendedPreset": "模型變更時詢問是否使用建議設定",
    "recommendedPreset": "使用建議設定",
    "persona": "使用者資訊",
    "icon": "圖示",
    "account": "帳號",
    "remove": "刪除",
    "creationSuccess": "創建成功",
    "noweb": "此功能無法於網頁版使用。",
    "createBotInternet": "使用 AI 從網路創建機器人",
    "createBotInternetAlert": "請提供角色名稱及對應的系列或遊戲。",
    "able": "啟用",
    "assetWidth": "額外資源圖片最大寬度",
    "animationSpeed": "動畫速度",
    "screenshot": "截圖",
    "screenshotSaved": "截圖已保存",
    "inputBotGenerationPrompt": "輸入機器人生成提示詞",
    "createBotAI": "使用 AI 創建原創機器人",
    "createBotwithAI": "使用 AI 創建機器人",
    "changeFolderName": "輸入新資料夾名稱（留空以取消）",
    "cancel": "取消",
    "renameFolder": "重新命名資料夾",
    "changeFolderColor": "變更資料夾顏色",
    "changeFolderImage": "變更資料夾圖片",
    "fullWordMatching": "完整單詞匹配",
    "botSettingAtStart": "啟動時顯示機器人選單",
    "triggerStart": "聊天發送時觸發",
    "triggerInput": "使用者輸出時觸發",
    "triggerOutput": "角色輸出時觸發",
    "triggerManual": "僅限手動觸發",
    "triggerCondVar": "如果變數為",
    "triggerCondExists": "如果聊天中存在文字",
    "triggerScript": "觸發式",
    "triggerMatchRegex": "與正規表達式匹配",
    "triggerMatchLoose": "寬鬆匹配",
    "triggerMatchStrict": "嚴格匹配",
    "searchDepth": "搜尋深度",
    "equal": "等於",
    "notEqual": "不等於",
    "greater": "大於",
    "less": "小於",
    "greaterEqual": "大於或等於",
    "lessEqual": "小於或等於",
    "triggerEffSysPrompt": "添加系統提示詞",
    "triggerEffSetVar": "修改變數",
    "triggerEffImperson": "發送聊天訊息",
    "triggerEffCommand": "執行指令",
    "triggerEffRunTrigger": "執行觸發式",
    "triggerEffStop": "停止發送提示詞",
    "triggerEffCall": "呼叫觸發式",
    "varableName": "變數名",
    "role": "身份",
    "location": "位置",
    "promptstart": "提示詞開始",
    "promptend": "提示詞結束",
    "historyend": "聊天歷史結束",
    "always": "總是",
    "noEffect": "無效果",
    "invaildTriggerEffect": "此效果不適用於該觸發類型。",
    "operator": "運算符",
    "TriggerSetToVar": "設定為變數",
    "TriggerAddToVar": "增加為變數",
    "TriggerSubToVar": "從變數中減去",
    "TriggerMulToVar": "將變數乘以",
    "TriggerDivToVar": "將變數除以",
    "isNull": "尚未設定",
    "ifChatIndex": "如果對話索引",
    "ifRandom": "如果隨機",
    "ifValue": "如果值",
    "hideRealm": "隱藏 RisuRealm",
    "popularityLevel": "{} 人氣",
    "colorScheme": "配色方案",
    "rangeStart": "範圍開始",
    "rangeEnd": "範圍結束",
    "untilChatEnd": "直到聊天結束",
    "usePromptTemplate": "使用提示詞模板",
    "specialType": "特殊類型",
    "noSpecialType": "無特殊類型",
    "forceProxyAsOpenAI": "強制代理格式為 OpenAI",
    "promptTemplate": "提示詞模板",
    "customInnerFormat": "自訂內部格式",
    "innerFormat": "內部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "啟動 HypaMemory",
    "resetPromptTemplateConfirm": "您真的確定要重置提示詞模板嗎？",
    "emotionMethod": "情緒檢測方式",
    "continueResponse": "繼續回應",
    "showMenuChatList": "在選單中顯示聊天列表",
    "translatorLanguage": "翻譯目標語言",
    "translatorType": "翻譯器類型",
    "htmlTranslation": "HTML 翻譯",
    "deeplKey": "DeepL API 金鑰",
    "deeplFreeKey": "DeepL 免費 API 金鑰",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "匯出使用者設定",
    "importPersona": "匯入使用者設定",
    "export": "匯出",
    "import": "匯入",
    "supporterThanks": "支持者鳴謝",
    "supporterThanksDesc": "感謝您的支持！",
    "donatorPatreonDesc": "為保護隱私，默認不會顯示在名單中。若想顯示您的暱稱，請前往叡甦的 Patreon 頁面並點擊連結按鈕。",
    "useNamePrefix": "使用名稱前綴",
    "textAdventureNAI": "以文字冒險形式運行",
    "appendNameNAI": "附加名稱至 NAI",
    "customStopWords": "自訂停止詞",
    "defaultPrompt": "預設提示詞",
    "additionalText": "額外提示",
    "seed": "Seed",
    "charjs": "角色 JavaScript",
    "depthPrompt": "提示詞深度",
    "largePortrait": "肖像",
    "lorePlus": "LoreBook+",
    "reverseProxyOobaMode": "Ooba Mode",
    "joinMultiUserRoom": "加入使用者多人聊天室",
    "exactTokens": "精確 Tokens",
    "fixedTokens": "估算 Tokens",
    "inlayViewScreen": "內嵌視窗",
    "imgGenPrompt": "圖片生成提示詞",
    "imgGenNegatives": "圖片生成負面提示詞",
    "imgGenInstructions": "系統提示詞",
    "usePlainFetchWarn": "使用 NovelAI 時請關閉此選項，避免出現 CORS 錯誤。",
    "translationPrompt": "翻譯提示詞",
    "translationResponseSize": "翻譯回應長度",
    "webdeeplwarn": "此功能不不建議於網頁版使用，避免出現 CORS 錯誤。",
    "saveBackupLocal": "本地保存備份",
    "loadBackupLocal": "本機讀取備份",
    "topP": "Top P",
    "genTimes": "生成次數",
    "cot": "思維鏈（CoT）",
    "forcePlainFetch": "強制簡單抓取",
    "autoFillRequestURL": "自動填入請求 URL",
    "newOAIHandle": "新的 OpenAI 處理方式",
    "oaiRandomUser": "放置 OAI 隨機使用者",
    "inlayImage": "內嵌圖片功能",
    "nativeAutomark": "實驗性本地自動標記",
    "assistantPrefill": "助理預填充",
    "postEndInnerFormat": "結尾內部格式",
    "sendChatAsSystem": "以系統身份發送訊息",
    "sendName": "非群聊時發送名稱",
    "utilOverride": "實用程式覆寫",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始身份發送",
    "exportAsDataset": "匯出保存資料為數據集",
    "editTranslationDisplay": "修改翻譯顯示",
    "selectModel": "選擇模型",
    "autoRemoveThoughtTag": "刪除思維標記",
    "customChainOfThought": "自訂思維鏈",
    "maxThoughtTagDepth": "思維標記最大深度",
    "openrouterFallback": "Openrouter 回退",
    "openrouterMiddleOut": "Openrouter 中間輸出",
    "geminiApiKey": "Gemini API 金鑰",
    "removePunctuationHypa": "移除記憶標記",
    "memoryLimitThickness": "記憶上限厚度",
    "inputCardPassword": "輸入角色卡密碼",
    "ccv2Desc": "V2 角色卡是廣泛用於聊天機器人前端的格式。",
    "ccv3Desc": "V3 角色卡是用於聊天機器人前端的新型格式。",
    "realmDesc": "RisuRealm 是叡甦的內容分享平台，您可以將角色分享給其他使用者。",
    "rccDesc": "Risu Refined 角色卡具有密碼保護、完整性驗證等附加功能。",
    "password": "密碼",
    "license": "授權",
    "licenseDesc": "您可以設定下載授權，限制角色卡對提示詞的使用。",
    "passwordDesc": "您可以為角色卡設置密碼，防止未經授權的訪問。",
    "largePersonaPortrait": "使用者肖像",
    "module": "模組",
    "modules": "模組",
    "noModules": "尚未安裝任何模組。",
    "createModule": "建立模組",
    "basicInfo": "基本資料",
    "moduleContent": "模組內容",
    "confirmRemoveModuleFeature": "確定要移除此功能嗎？此操作無法還原。",
    "editModule": "編輯模組",
    "importModule": "匯入模組",
    "download": "下載",
    "edit": "編輯",
    "enableGlobal": "全域啟用",
    "chatModulesInfo": "可選擇開啟或關閉此對話的模組。",
    "sideMenuRerollButton": "側欄選單重新載入",
    "persistentStorage": "永久儲存",
    "persistentStorageSuccess": "儲存已成功永久化",
    "persistentStorageFail": "儲存未能永久化。您是否拒絕了請求，或瀏覽器不支持？",
    "persistentStorageRecommended": "建議使用永久儲存",
    "persistentStorageDesc": "您的瀏覽器支持永久儲存，建議啟用以提升效能和使用者體驗。",
    "enable": "啟用",
    "postFile": "上傳檔案",
    "requestInfoInsideChat": "在聊天中顯示請求資料",
    "inputTokens": "輸入 Tokens",
    "outputTokens": "輸出 Tokens",
    "tokenWarning": "Token 計算可能不精確，僅作參考。",
    "log": "記錄",
    "popularityLevelDesc": "人氣會隨著下載量等增加。3.7 人氣約等於 1 次下載。",
    "additionalParams": "額外參數",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用進階編輯器",
    "noWaitForTranslate": "不等待翻譯",
    "updateRealm": "更新至 RisuRealm",
    "updateRealmDesc": "您正試圖將角色更新至 RisuRealm。此操作將使角色更新至 RisuRealm，且無法還原。",
    "antiClaudeOverload": "防止 Claude 超載",
    "activeTabChange": "目前的標籤已停用，因其他標籤處於活動中。若要啟動此標籤，請按「確定」。",
    "maxSupaChunkSize": "最大 SupaMemory Chunk 大小",
    "addCharacter": "新增角色",
    "importFromRealm": "從 RisuRealm 選擇",
    "importFromRealmDesc": "RisuRealm 提供超過 1000 位角色",
    "random": "隨機",
    "metaData": "Metadata",
    "autoContinueMinTokens": "目標 Tokens（自動繼續）",
    "autoContinueChat": "防止不完整回覆（自動繼續）",
    "removeIncompleteResponse": "移除不完整句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "聊天格式",
    "useInstructPrompt": "啟用指令提示詞",
    "hanuraiMemory": "HanuraiMemory",
    "playground": "Playground",
    "textAreaSize": "輸入欄大小",
    "textAreaTextSize": "輸入欄文字大小",
    "sideBarSize": "側邊欄大小",
    "embedding": "嵌入",
    "syntax": "語法",
    "run": "執行",
    "noMessage": "輸入內容以開始聊天。",
    "combineTranslation": "合併翻譯",
    "dynamicAssets": "動態資源",
    "dynamicAssetsEditDisplay": "在介面上使用動態資源",
    "longTermMemory": "長期記憶",
    "grid": "網格",
    "list": "列表",
    "trash": "垃圾桶",
    "trashDesc": "刪除的角色將移至垃圾桶，可選擇還原或永久刪除。刪除的角色將在 3 天後自動永久刪除。",
    "shareExport": "分享/匯出",
    "risupresetDesc": "Risupreset 是專為叡甦預設設定設計的格式。",
    "risuMDesc": "RisuM 是專為叡甦模組設計的格式。",
    "jsonDesc": "JSON 是一種人機都易於讀寫的格式。",
    "nickname": "暱稱",
    "useRegexLorebook": "使用正規表達式",
    "customPromptTemplateToggle": "自訂開關",
    "defaultVariables": "預設變數",
    "hypaAllocatedTokens": "已分配的 Tokens",
    "hypaChunkSize": "Chunk 大小",
    "hypaV2Desc": "HypaMemory V2 是一種結合摘要資料和向量搜尋的長期記憶系統。",
    "supaDesc": "SupaMemory 是一種使用摘要資料的長期記憶系統。",
    "hanuraiDesc": "HanuraiMemory 是一個使用向量搜尋的記憶系統。",
    "lowLevelAccess": "低層級訪問",
    "resultStoredVar": "儲存結果的變數",
    "triggerEffRunLLM": "執行主要模型",
    "triggerEffectSendAI": "重新發送 AI",
    "triggerEffCheckSim": "檢查相似度",
    "triggerEffShowAlert": "顯示警告",
    "normal": "正常",
    "error": "錯誤",
    "input": "輸入",
    "select": "選擇",
    "lowLevelAccessConfirm": "此內容使用低層級訪問，可直接存取 AI 模型和您的儲存資料。您確定要匯入嗎？",
    "triggerLowLevelOnly": "此觸發僅適用於低層級訪問，需在角色或模組的進階設定中啟用低層級訪問。",
    "truthy": "真值",
    "extractRegex": "使用正規表達式提取文字",
    "runImgGen": "執行圖片生成",
    "cutChat": "分割聊天",
    "modifyChat": "修改聊天",
    "regex": "正規表達式",
    "flags": "修飾詞",
    "resultFormat": "結果格式",
    "negPrompt": "負面提示詞",
    "start": "開始",
    "end": "結束",
    "index": "索引",
    "search": "搜尋",
    "goCharacterOnImport": "導入後跳轉至角色頁面",
    "format": "格式",
    "v2Warning": "警告：已停止支援 V2 角色卡，可能會缺失部分資料。",
    "applyModule": "套用模組",
    "successApplyModule": "已成功套用模組",
    "font": "字型",
    "lineHeight": "行距",
    "loadAutoServerBackup": "讀取伺服器自動備份",
    "notCharxWarn": "角色使用多項資源，建議匯出為 CharX 格式以提升相容性。",
    "noPlugins": "未安裝外掛",
    "legacyTranslation": "舊版翻譯",
    "clipboardSuccess": "已複製到剪貼簿",
    "translateContent": "翻譯內容",
    "doNotTranslate": "不進行翻譯",
    "includePersonaName": "包含使用者名稱",
    "hidePersonaName": "隱藏使用者名稱",
    "triggerSwitchWarn": "更改觸發類型後，現有觸發將被清除。您確定要繼續嗎？",
    "codeMode": "程式碼",
    "blockMode": "區塊",
    "helpBlock": "幫助",
    "hideChatIcon": "隱藏頭像",
    "loadInternalBackup": "讀取內部備份",
    "createCopy": "新建副本",
    "bindPersona": "綁定使用者",
    "chatOptions": "聊天選項",
    "doYouWantToBindCurrentPersona": "是否綁定當前使用者至此聊天？",
    "doYouWantToUnbindCurrentPersona": "是否解除此對話中的使用者綁定？",
    "personaBindedSuccess": "使用者綁定已完成",
    "personaUnbindedSuccess": "使用者綁定已解除",
    "parameters": "參數",
    "sizeAndSpeed": "大小與速度",
    "useLegacyGUI": "使用舊版介面",
    "claudeCachingExperimental": "Claude 快取",
    "openClose": "開啟／關閉",
    "hideApiKeys": "隱藏 API 金鑰",
    "unformatQuotes": "禁用引號格式",
    "enableDevTools": "啟用開發者工具",
    "selectFile": "選擇檔案",
    "namespace": "命名空間",
    "moduleIntergration": "模組整合",
    "previewInfo": "此預覽顯示模型處理前的提示詞。",
    "miscTools": "其他工具",
    "promptConvertion": "提示詞轉換",
    "convertionStep1": "選擇與提示詞相關的檔案（支持 Context、Instruct 及 Sampler JSON）",
    "customCSS": "自訂 CSS",
    "betaMobileGUI": "測試版行動介面",
    "menu": "選單",
    "connectionOpen": "已開啟連線",
    "connectionOpenInfo": "多人聊天室已開啟，您可以將聊天室代碼分享給其他使用者。其他使用者可在 Playground > 加入多人聊天室 > 使用代碼加入。",
    "createMultiuserRoom": "新建多人聊天室",
    "connectionHost": "您是聊天室的主持人。",
    "connectionGuest": "您是聊天室的訪客。",
    "otherUserRequesting": "其他使用者正在請求中，請稍後重試。",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "Enable Schema",
    "strictJsonSchema": "Strict Schema",
    "extractJson": "提取 JSON",
    "reloadSession": "發現更新版本的儲存資料，正在重新載入對話⋯",
    "fixMarkdownNewline": "修正 Markdown 換行",
    "customQuotes": "自訂引號",
    "leadingSingleQuote": "上單引號",
    "leadingDoubleQuote": "上雙引號",
    "trailingSingleQuote": "下單引號",
    "trailingDoubleQuote": "下雙引號",
    "translatorNote": "翻譯器備註",
    "formatGroupInSingle": "單一群組格式",
    "groupInnerFormat": "非發言者內部格式",
    "groupOtherBotRole": "群組內非發言者的身份",
    "defineCustomGUI": "自定義界面",
    "chatHTML": "聊天介面 HTML",
    "logShare": "顯示分享記錄按鈕",
    "preview": "預覽",
    "recommended": "推薦",
    "newChat": "新對話",
    "predictedOutput": "預測輸出",
    "systemContentReplacement": "替換系統內容",
    "systemRoleReplacement": "替換系統角色",
    "seperateParameters": "分離參數",
    "seperateParametersEnabled": "啟用分離參數",
    "summarizationPrompt": "摘要提示詞",
    "translatorPrompt": "翻譯提示詞",
    "translateBeforeHTMLFormatting": "於 HTML 格式化前翻譯",
    "retranslate": "重新翻譯",
    "loading": "載入中",
    "autoTranslateCachedOnly": "僅自動翻譯已快取訊息",
    "notification": "使用系統通知",
    "permissionDenied": "權限被您的瀏覽器或操作系統拒絕",
    "customFlags": "自定義修飾詞（Flags）",
    "enableCustomFlags": "啟用自定義修飾詞（Flags）",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "預設鏈",
    "legacyMediaFindings": "舊版媒體發現",
    "staticsDisclaimer": "統計資料基於 2024 年 7 月之後的數據，可能不完全準確。",
    "subtitles": "字幕",
    "subtitlesWarning1": "您必須使用具有音訊／視訊輸入的模型才能使用此功能。",
    "subtitlesWarning2": "您必須使用具有即時串流傳輸功能的模型才能使用此功能。",
    "reset": "重置",
    "assetMaxDifference": "資源最大差異",
    "sourceLanguage": "原文語言",
    "destinationLanguage": "目標語言",
    "noWebGPU": "由於目前的瀏覽器或作業系統不支援 WebGPU，效能將大幅下降。",
    "menuSideBar": "選單側邊欄",
    "home": "首頁",
    "showSavingIcon": "顯示儲存圖示",
    "pluginVersionWarn": "這是 {{plugin_version}} 版本的外掛程式，與當前 RisuAI 版本不相容。請更新外掛至 {{required_version}} 版本。",
    "imageTranslation": "圖像翻譯",
    "banCharacterset": "自動重新生成字符集",
    "checkCorruption": "檢查損壞",
    "showPromptComparison": "顯示提示比較",
    "inlayErrorResponse": "嵌入錯誤回應",
    "APIPool": "API 工具",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是一個使用摘要和向量搜索的長期記憶系統。",
        "supaMemoryPromptPlaceHolder": "留空以使用預設值",
        "maxMemoryTokensRatioLabel": "最大記憶標記比率（估計）",
        "maxMemoryTokensRatioError": "無法計算最大記憶標記比率",
        "memoryTokensRatioLabel": "記憶標記比率",
        "extraSummarizationRatioLabel": "額外摘要比率",
        "maxChatsPerSummaryLabel": "每個摘要的最大訊息數",
        "recentMemoryRatioLabel": "最近記憶比率",
        "similarMemoryRatioLabel": "相似記憶比率",
        "randomMemoryRatioLabel": "隨機記憶比率",
        "enableSimilarityCorrectionLabel": "啟用相似度校正",
        "preserveOrphanedMemoryLabel": "保留孤立記憶",
        "applyRegexScriptWhenRerollingLabel": "重新生成時應用正則表達式腳本",
        "doNotSummarizeUserMessageLabel": "不要摘要用戶訊息"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3 數據",
        "resetConfirmMessage": "此操作無法撤銷。您要重置 HypaV3 數據嗎？",
        "resetConfirmSecondMessage": "此操作不可逆。您真的確定要重置 HypaV3 數據嗎？",
        "convertLabel": "尚無摘要，但您可以將 HypaV2 數據轉換為 V3。",
        "convertButton": "轉換為 V3",
        "convertSuccessMessage": "成功將 HypaV2 數據轉換為 V3",
        "convertErrorMessage": "無法將 HypaV2 數據轉換為 V3：{0}",
        "noSummariesLabel": "尚無摘要",
        "searchPlaceholder": "輸入 #N、ID 或搜尋關鍵字",
        "summaryNumberLabel": "摘要 #{0}",
        "deleteThisConfirmMessage": "刪除此摘要？",
        "deleteAfterConfirmMessage": "刪除此摘要之後的所有摘要？",
        "deleteAfterConfirmSecondMessage": "此操作無法撤銷。您確定要這樣做嗎？",
        "translationLabel": "翻譯",
        "rerolledSummaryLabel": "重新生成的摘要",
        "rerolledTranslationLabel": "重新生成的摘要翻譯",
        "connectedMessageCountLabel": "關聯訊息（{0}）",
        "connectedFirstMessageLabel": "第一條訊息",
        "connectedMessageRoleLabel": "{0} 的訊息",
        "connectedMessageNotFoundLabel": "找不到訊息",
        "connectedMessageLoadingError": "載入關聯訊息時出錯：{0}",
        "connectedMessageTranslationLabel": "翻譯",
        "nextSummarizationFirstMessageLabel": "第一條訊息",
        "nextSummarizationNoMessageIdLabel": "無訊息 ID",
        "nextSummarizationLabel": "HypaV3 將摘要 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：找不到訊息",
        "nextSummarizationLoadingError": "載入下一個摘要目標時出錯：{0}",
        "summarizationConditionLabel": "提示：當輸入標記超過最大上下文大小時，HypaV3 將開始進行摘要處理。",
        "emptySelectedFirstMessageLabel": "警告：選定的第一條訊息為空"
    },
}
